import request from '@/utils/request'

export function getAllLevel2(level1) {
    return request({
        url: '/web/Special/getAllLevel2',
        method: 'post',
        data: {
            level1: level1,
        }
    })
}
export function getSpecialList(special_name,level1,level2,page) {
    return request({
        url: '/web/Special/getSpecialList',
        method: 'post',
        data: {
            special_name: special_name,
            level1: level1,
            level2: level2,
            p: page,
        }
    })
}
export function getSpecialDetail(special_id) {
    return request({
        url: '/web/Special/getSpecialDetail',
        method: 'post',
        data: {
            special_id: special_id,
        }
    })
}
export function getRelateSchool(special_id,page) {
    return request({
        url: '/web/Special/getRelateSchool',
        method: 'post',
        data: {
            special_id: special_id,
            p: page,
        }
    })
}